import { cn } from '@/lib/utils';
import { Button } from './ui/button';
export function ActionButton({
  onClick,
  className,
  children,
  type,
  disabled
}: {
  onClick?: () => void;
  className?: string;
  children: React.ReactNode;
  type?: 'button' | 'submit' | 'reset' | undefined;
  disabled?: boolean;
}) {
  return <Button type={type || 'button'} onClick={onClick} disabled={disabled} className={cn(`md:px-2.5 mt-1 w-full cursor-pointer overflow-hidden rounded-lg bg-x-accent-alpha py-3 text-center text-sm font-semibold leading-none tracking-tight text-white max-md:max-w-full md:static hover:opacity-95`, className)} data-sentry-element="Button" data-sentry-component="ActionButton" data-sentry-source-file="action-button.tsx">
      {children}
    </Button>;
}